import React, { useEffect,useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import TimeSlots from '../../../../Shared/TimeSlots/TimeSlots';
import { setTechnicianSelectedDay, setTechnicianSelectedHours } from '../../ServiceAppointmentBlockSlice';
import { goToNextPageAsync } from '../../ServiceAppointmentAsyncthunk';
import { reportDWH } from '../../ServiceAppointmentBlockSlice';

const TechnicianPage = (props) => {

    function handleOnSelectDay(day){
        props.setTechnicianSelectedDay(day);
    }

    function handleOnSelectHours(time){
        props.setTechnicianSelectedHours(time);
    }

    function handleOnContinue() {
        props.reportDWH({ actionType: 'TechnicianOrder', status: 'Completed', messageText: 'Technician Order Completed' });
        props.goToNextPageAsync();
    }

    useEffect(() => {
        //props.reportDWH({ actionType: 'TechnicianOrder', status: 'Ongoing', messageText: 'Technician Order Completed' });
    }, []);

  return (
      <div className='service-appointment-technician-page page-wrapper'>
        <div className='content'>
        <div className='title-wrapper'>
        {props.isTimeSlotOccupied ? <h1>מצטערים, זמן הגעת הטכנאי שבחרת כבר לא פנוי</h1>:<h1>נוכל להגיע אליך כבר ביום {props.firstTechnicianTimeDisplay}</h1>}
        <h2>לשינוי, יש לבחור את היום והשעה הנוחים לך</h2>
        <h3>כתובת: <span className='address'>{props.fullAddress}</span></h3>
        </div>
        <TimeSlots technicianTimes={props.timeSlots} onSelectDay={handleOnSelectDay} onSelectHours={handleOnSelectHours} />
        </div>
        <div className='button-wrapper'>
            <BtnSubmit
                isBusiness={false}
                text={'אישור והזמנה'}
                onclick={handleOnContinue}
                formid='technician-page'
                isDisplayArrows={false}
            />
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    timeSlots : state.serviceAppointmentSchedulerBlock.technicianPage?.timeSlots,
    fullAddress: state.serviceAppointmentSchedulerBlock.subscriber?.address?.fullAddress,
    firstTechnicianTimeDisplay: state.serviceAppointmentSchedulerBlock.technicianPage?.firstTechnicianTimeDisplay,
    isTimeSlotOccupied: state.serviceAppointmentSchedulerBlock.technicianPage?.isTimeSlotOccupied
};
}

const mapDispatchToProps = { setTechnicianSelectedDay, setTechnicianSelectedHours, goToNextPageAsync, reportDWH};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianPage);
